import { render, staticRenderFns } from "./WineryGeneral.vue?vue&type=template&id=8aaa0fb0&"
import script from "./WineryGeneral.vue?vue&type=script&lang=js&"
export * from "./WineryGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports